import React, { useEffect, useState } from 'react';
import baseURL from '../url';
import './LinksNav.css';
import { useParams, useNavigate, Link as Anchor } from "react-router-dom";
import { Toast } from 'primereact/toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faPlus, faArrowLeft, faStore } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';

// Establecer el elemento para el modal
Modal.setAppElement('#root');

export default function LinksNav() {
    const [tienda, setTienda] = useState(null);
    const { idTienda } = useParams();
    const [categorias, setCategorias] = useState([]);
    const [tiendas, setTiendas] = useState([]);
    const [productos, setProductos] = useState([]);
    const [categoriasProductos, setCategoriasProductos] = useState([]);
    const [showModal, setShowModal] = useState(false); // Estado para mostrar el modal
    const [modalView, setModalView] = useState('tiendas'); // Estado para la vista activa en el modal
    const toast = React.useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        cargarTiendas();
        cargarCategoriaProductos();
        cargarCategoriaTienda();
    }, [idTienda]);

    const cargarTiendas = async () => {
        let tiendasData = [];
        try {
            const response = await fetch(`${baseURL}/tiendasFrontend.php`, {
                method: 'GET',
                credentials: 'include'
            });
            const data = await response.json();
            if (Array.isArray(data?.tiendas) && data.tiendas.length > 0) {
                tiendasData = data.tiendas;
            }
        } catch (error) {
            console.warn('tiendasFrontend.php falló en LinksNav, usando tiendaGet.php...', error);
        }

        if (tiendasData.length === 0) {
            try {
                const fallbackRes = await fetch(`${baseURL}/tiendaGet.php`, {
                    method: 'GET',
                    credentials: 'include'
                });
                const fallbackData = await fallbackRes.json();
                if (Array.isArray(fallbackData?.tiendas)) {
                    tiendasData = fallbackData.tiendas.filter(t => !t.estado || t.estado === 'visible');
                }
            } catch (errFallback) {
                console.error('Error en fallback tiendaGet.php en LinksNav:', errFallback);
            }
        }

        setTiendas(tiendasData);
        const tiendaEncontrada = tiendasData.find(t => Number(t.idTienda) === Number(idTienda));
        setTienda(tiendaEncontrada);
        setProductos(tiendasData.flatMap(t => t?.productos || []) || []);
    };

    const cargarCategoriaTienda = () => {
        fetch(`${baseURL}/categoriaTiendaGet.php`, {
            method: 'GET',
            credentials: 'include'
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarCategoriaProductos = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
            credentials: 'include'
        })
            .then(response => response.json())
            .then(data => {
                setCategoriasProductos(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const obtenerImagen = (item) => {
        if (item.imagen1) {
            return item.imagen1;
        } else if (item.imagen2) {
            return item.imagen2;
        } else if (item.imagen3) {
            return item.imagen3;
        } else if (item.imagen4) {
            return item.imagen4;
        }
        return null;
    };

    const handleSelectCategoriaTienda = (cat) => {
        setShowModal(false);
        const catId = typeof cat === 'object' ? cat.idCategoria : cat;
        const catObj = typeof cat === 'object' ? cat : categorias.find(c => Number(c.idCategoria) === Number(catId));
        const slug = ((catObj?.categoria) || '').replace(/\s+/g, '-');
        navigate(`/categoria-tiendas/${catId}${slug ? `/${slug}` : ''}`);
    };

    const productosPorCategoria = categoriasProductos
        .map(categoria => ({
            ...categoria,
            productos: productos.filter(producto => Number(producto.idCategoria) === Number(categoria.idCategoria))
        }))
        .filter(categoria => categoria.productos.length > 0);

    return (
        <div className="containerLinks">
            <Toast ref={toast}></Toast>

            <div className="menu-item">
                Categorías
                <FontAwesomeIcon icon={faChevronDown} style={{ marginLeft: '10px' }} />
                <div className="submenu submenu-categorias">
                    {categorias.length > 0 ? (
                        categorias.map(categoria => {
                            const count = categoria.cantidad_tiendas !== undefined 
                                ? Number(categoria.cantidad_tiendas) 
                                : tiendas.filter(t => Number(t.idCategoria) === Number(categoria.idCategoria)).length;
                            return (
                                <button
                                    key={categoria.idCategoria}
                                    type="button"
                                    className="item-categoria-nav"
                                    onClick={() => handleSelectCategoriaTienda(categoria.idCategoria)}
                                >
                                    {categoria.imagen ? (
                                        <div style={{ position: 'relative', display: 'inline-flex' }}>
                                            <img
                                                src={categoria.imagen}
                                                alt={categoria.categoria}
                                                className="item-categoria-img"
                                                onError={(e) => { e.target.style.display = 'none'; }}
                                            />
                                            {categoria.color && (
                                                <span
                                                    style={{
                                                        position: 'absolute',
                                                        bottom: '-1px',
                                                        right: '-1px',
                                                        width: '9px',
                                                        height: '9px',
                                                        borderRadius: '50%',
                                                        backgroundColor: categoria.color,
                                                        border: '1.5px solid #ffffff'
                                                    }}
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <div
                                            className="item-categoria-placeholder"
                                            style={categoria.color ? { backgroundColor: `${categoria.color}20`, color: categoria.color } : {}}
                                        >
                                            <FontAwesomeIcon icon={faStore} />
                                        </div>
                                    )}
                                    <div className="item-categoria-text">
                                        <span className="item-categoria-title">{categoria.categoria}</span>
                                        <span className="item-categoria-count">{count} {count === 1 ? 'tienda' : 'tiendas'}</span>
                                    </div>
                                </button>
                            );
                        })
                    ) : (
                        <div style={{ padding: '10px', color: '#888', fontSize: '13px' }}>
                            Cargando categorías...
                        </div>
                    )}
                </div>
            </div>

            <div className="menu-item" style={{ marginTop: '20px' }}>
                Productos
                <FontAwesomeIcon icon={faChevronDown} style={{ marginLeft: '10px' }} />
                <div className="submenu">
                    {productosPorCategoria.map(categoria => (
                        <div key={categoria.idCategoria} className="categoria-container">
                            <h6>{categoria.categoria}</h6>
                            <hr />
                            {categoria.productos.map(producto => (
                                <Anchor key={producto.idProducto} to={`/producto/${producto.idProducto}/${producto.titulo.replace(/\s+/g, '-')}`}>
                                    <img src={obtenerImagen(producto)} alt="imagen" />
                                    {producto.titulo}
                                </Anchor>
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            {/* Icono + para pantallas pequeñas */}
            <button
                className="toggle-button"
                onClick={() => setShowModal(true)} // Abrir el modal
            >
                <FontAwesomeIcon icon={faPlus} />
            </button>

            {/* Modal para pantallas pequeñas */}
            <Modal
                isOpen={showModal}
                onRequestClose={() => setShowModal(false)} // Cerrar el modal al hacer clic fuera del contenido
                className="modalLinks"
                overlayClassName="overlayInput"
                contentLabel="Menu Modal"
            >
                <div>
                    <div className='deFLex'>
                        <button onClick={() => setShowModal(false)} >
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                    </div>
                    <div className="modal-flexButons">
                        <button
                            className={`modal-button ${modalView === 'tiendas' ? 'active' : ''}`}
                            onClick={() => setModalView('tiendas')}
                        >
                            Categorías
                        </button>
                        <button
                            className={`modal-button ${modalView === 'productos' ? 'active' : ''}`}
                            onClick={() => setModalView('productos')}
                        >
                            Productos
                        </button>
                    </div>
                    {modalView === 'tiendas' ? (
                        <div className="submenu-modal-categorias">
                            {categorias.length > 0 ? (
                                categorias.map(categoria => {
                                    const count = categoria.cantidad_tiendas !== undefined 
                                        ? Number(categoria.cantidad_tiendas) 
                                        : tiendas.filter(t => Number(t.idCategoria) === Number(categoria.idCategoria)).length;
                                    return (
                                        <button
                                            key={categoria.idCategoria}
                                            type="button"
                                            className="item-categoria-nav"
                                            onClick={() => handleSelectCategoriaTienda(categoria.idCategoria)}
                                        >
                                            {categoria.imagen ? (
                                                <img
                                                    src={categoria.imagen}
                                                    alt={categoria.categoria}
                                                    className="item-categoria-img"
                                                    onError={(e) => { e.target.style.display = 'none'; }}
                                                />
                                            ) : (
                                                <div className="item-categoria-placeholder">
                                                    <FontAwesomeIcon icon={faStore} />
                                                </div>
                                            )}
                                            <div className="item-categoria-text">
                                                <span className="item-categoria-title">{categoria.categoria}</span>
                                                <span className="item-categoria-count">{count} {count === 1 ? 'tienda' : 'tiendas'}</span>
                                            </div>
                                        </button>
                                    );
                                })
                            ) : (
                                <p style={{ padding: '1rem', color: '#888' }}>No hay categorías de tiendas disponibles.</p>
                            )}
                        </div>

                    ) : (

                        <div className="submenu">
                            {productosPorCategoria.length > 0 ? (
                                productosPorCategoria.map(categoria => (
                                    <div key={categoria.idCategoria} className="categoria-container">
                                        <h6>{categoria.categoria}</h6>
                                        <hr />
                                        {categoria.productos.map(producto => (
                                            <Anchor key={producto.idProducto} to={`/producto/${producto.idProducto}/${producto.titulo.replace(/\s+/g, '-')}`} onClick={() => setShowModal(false)}>
                                                <img src={obtenerImagen(producto)} alt="imagen" />
                                                {producto.titulo}
                                            </Anchor>
                                        ))}
                                    </div>
                                ))
                            ) : (
                                <p>No hay productos disponibles.</p>
                            )}
                        </div>

                    )}
                </div>
            </Modal>
        </div>
    );
}
